import { render, staticRenderFns } from "./OPartLink.vue?vue&type=template&id=683cab7f&"
import script from "./OPartLink.vue?vue&type=script&setup=true&lang=js&"
export * from "./OPartLink.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports